import { KioskOs, ModelType } from '@biteinc/enums';

app.KioskStatus = app.AbstractModel.extend({
  ModelName: 'gazeboStatus',
  Schema: {
    displayName: 'kiosk status',
  },
  Type: ModelType.KioskStatus,

  canReceivePusherNotifications() {
    return this.hasStr('pusherChannel');
  },

  isIOS() {
    return this.get('deviceStatus').os === KioskOs.iOS;
  },

  isAndroid() {
    return this.get('deviceStatus').os === KioskOs.Android;
  },

  isGarcon() {
    return !!this.get('deviceStatus').garconBuildName;
  },
});
